import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaSistemaCalidad({ idSolicitud }) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [archivos, setArchivos] = useState(null);
  const [formData, setFormData] = useState({
    implementado: "",
    especifique: "",
    auditoriasInternas: "",
    especificacionAuditoriasInternas: "",
    grupos: "",
    especifiqueGrupos: "",
    herramientas: "",
    especifiqueHerramientas: "",
  });

  const handleOpenModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => setArchivos(e.target.files);

  const insertarArchivos = async () => {
    // Validaciones
    if (!formData.implementado || !formData.auditoriasInternas) {
      alert("Debe responder todas las preguntas requeridas.");
      return;
    }

    if (formData.implementado === "si" && !formData.especifique.trim()) {
      alert("Debe especificar el sistema de calidad implementado.");
      return;
    }

    if (
      formData.auditoriasInternas === "si" &&
      !formData.especificacionAuditoriasInternas.trim()
    ) {
      alert("Debe especificar las auditorías realizadas.");
      return;
    }

    if (!archivos || archivos.length === 0) {
      alert("Debe adjuntar al menos un archivo.");
      return;
    }

    const username = "BasicAuth@icontec.org";
    const password = "yQLzqmR7eZSuAmQZUqhY";
    const authHeader = `Basic ${btoa(`${username}:${password}`)}`;

    const formDataFiles = new FormData();
    for (let i = 0; i < archivos.length; i++) {
      formDataFiles.append("files", archivos[i]);
    }

    try {
      await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/ArchivoSistemaCalidad?SolicitudId=${idSolicitud}&Implementado=${formData.implementado}&Especifique=${formData.especifique}&AuditoriasInternas=${formData.auditoriasInternas}&EspecificacionAuditoriasInternas=${formData.especificacionAuditoriasInternas}&InformeAuditoria=NA`,
        formDataFiles,
        {
          headers: {
            Authorization: authHeader,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      alert("¡Cargue con éxito!");
      window.location.reload("/");
    } catch (error) {
      console.error(error);
      alert("Error al cargar");
    }
  };

  return (
    <div>
      <button className="btn btn-primary btn-lg" onClick={handleOpenModal}>
        Sistema Calidad
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Sistema Calidad"
        ariaHideApp={false}
      >
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Crear Sistema Calidad
              </h6>
            </div>

            <div className="card-body">
              <form className="user">
                {/* Implementado */}
                <div className="form-group row align-items-center">
                  <label className="col-sm-6 col-form-label">
                    ¿La institución ha implementado otros sistemas de calidad?
                  </label>
                  <div className="col-sm-6">
                    <select
                      className="form-control"
                      name="implementado"
                      onChange={handleChange}
                      required
                    >
                      <option value="">Seleccione</option>
                      <option value="si">Sí</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                </div>

                {formData.implementado === "si" && (
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Especifique:
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control"
                        name="especifique"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                )}

                {/* Auditorías */}
                <div className="form-group row align-items-center">
                  <label className="col-sm-6 col-form-label">
                    ¿Se han realizado auditorías internas o externas al sistema
                    de gestión de calidad implementado?
                  </label>
                  <div className="col-sm-6">
                    <select
                      className="form-control"
                      name="auditoriasInternas"
                      onChange={handleChange}
                      required
                    >
                      <option value="">Seleccione</option>
                      <option value="si">Sí</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                </div>

                {formData.auditoriasInternas === "si" && (
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Especifique:
                    </label>
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control"
                        name="especificacionAuditoriasInternas"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                )}
                {/*
 <div className="form-group row align-items-center">
                  <label className="col-sm-6 col-form-label">
                    a. La institución ha implementado Grupos Relacionados al
                    Diagnóstico (GRD)
                  </label>
                  <div className="col-sm-6">
                    <select
                      className="form-control"
                      name="grupos"
                      onChange={handleChange}
                      disabled
                    >
                      <option value="">Seleccione</option>
                      <option value="si">Sí</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-sm-6 col-form-label">
                    Especifique:
                  </label>
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      name="especifiqueGrupos"
                      onChange={handleChange}
                      disabled
                    />
                  </div>
                </div>

                <div className="form-group row align-items-center">
                  <label className="col-sm-6 col-form-label">
                    b. La institución cuenta con otra herramienta de agrupación
                    diagnóstica
                  </label>
                  <div className="col-sm-6">
                    <select
                      className="form-control"
                      name="herramientas"
                      onChange={handleChange}
                      disabled
                    >
                      <option value="">Seleccione</option>
                      <option value="si">Sí</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-sm-6 col-form-label">
                    Especifique:
                  </label>
                  <div className="col-sm-6">
                    <input
                      type="text"
                      className="form-control"
                      name="especifiqueHerramientas"
                      onChange={handleChange}
                      disabled
                    />
                  </div>
                </div>
*/}
                {/* Archivos */}
                <div className="form-group row">
                  <label className="col-sm-6 col-form-label">
                    Adjuntar archivos:
                  </label>
                  <div className="col-sm-6">
                    <input
                      type="file"
                      name="files"
                      multiple
                      onChange={handleFileChange}
                      required
                    />
                  </div>
                </div>

                <button
                  className="btn btn-primary btn-block"
                  type="button"
                  onClick={insertarArchivos}
                >
                  Guardar
                </button>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaSistemaCalidad;
